import * as types from '../../mutation-types.js';
import http from '@service/http';
import util from '@common/utils/util';
import { tokenCall,restCall } from '@service/adapter';
import Constant from '@/Constant';
/**
 * 客户订单STORE
 */
export default {
  state: {
  	orderList:[],
  	orderMsg:{},//订单信息
  	orderMate:{},//料品数据
    treeData:{}
  },
  actions: {
    //存储料品树信息
    setTreeData({ commit },data) {
      console.log("TREE ===============",data)
      commit(types.TREE_DATA, data);
    },

  	//存储订单信息
    setOrderMsg({ commit },data) {
      commit(types.ORDER_MSG, data);
    },

    //存储料品数据
    setOrderMate({ commit },data) {
      commit(types.ORDER_MATE, data);
    },

    //获取订单分页数据
    getPageOrder({commit},data){
      return tokenCall(Constant.tokenCallUrl+'/mxorder/order/info/page',data,'get').then(res => {
        if (res.code == 200) {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject((res && res.message) || "获取数据失败");
        }
      }).catch(error => {
          return Promise.reject(error);
      }) 
    },

    //保存订单数据
    saveOrder({commit},data){
      return tokenCall(Constant.tokenCallUrl+'/mxorder/order/info/save',data,'post').then(res => {
        if (res.code == 200) {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject((res && res.message) || "获取数据失败");
        }
      }).catch(error => {
          return Promise.reject(error);
      }) 
    },
    //提交订单
    commitOrder({commit},data){
      return tokenCall(Constant.tokenCallUrl+'/mxorder/order/info/commit',data,'get').then(res => {
         if (res.code == 200) {
              return Promise.resolve(res.data);
          } else {
              return Promise.reject(res || "获取数据失败");
          }
      }).catch(error => {
            return Promise.reject(error);
        })
    },

    //获取订单详情
    getOrderDetail({commit},data){
      return tokenCall(Constant.tokenCallUrl+'/mxorder/order/info/getDetail',data,'get').then(res => {
         if (res.code == 200) {
              return Promise.resolve(res.data);
          } else {
              return Promise.reject(res || "获取数据失败");
          }
      }).catch(error => {
            return Promise.reject(error);
        })
    },

    //删除订单
    removeOrder({commit},data){
      return tokenCall(Constant.tokenCallUrl+'/mxorder/order/info/remove',data,'get').then(res => {
         if (res.code == 200) {
              return Promise.resolve(res.data);
          } else {
              return Promise.reject(res || "获取数据失败");
          }
      }).catch(error => {
            return Promise.reject(error);
        })
    },



   //获取料品分页数据
    getPageMateriel({commit},data){
      return tokenCall(Constant.tokenCallUrl+'/mxorder/materiel/info/pageMateriel',data,'get').then(res => {
      	if (res.code == 200) {
      		return Promise.resolve(res.data);
      	} else {
      		return Promise.reject((res && res.message) || "获取数据失败");
      	}
      }).catch(error => {
          return Promise.reject(error);
      }) 
    },

    // 料品配置项分页方法
    pageMaterielItemVal({commit},data){
      return tokenCall(Constant.tokenCallUrl+'/mxorder/materiel/info/pageMaterielItemVal',data,'post').then(res => {
      	if (res.code == 200) {
      		return Promise.resolve(res.data);
      	} else {
      		return Promise.reject((res && res.message) || "获取数据失败");
      	}
      }).catch(error => {
          return Promise.reject(error);
      }) 
    },

    //通过静态值constCode获取字典数据
    getConstValue({ commit }, data) {
      return tokenCall(Constant.tokenCallUrl + '/mxorder/sm/const/constValue', data, 'get').then(result => {
        if (result && result.data) {
          return Promise.resolve(result.data);
        } else {
          return Promise.reject((result && result.message) || "获取数据失败");
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    },

    //获取订单流程
    getOrderLogs({commit},data){
      return tokenCall(Constant.tokenCallUrl + '/mxorder/order/info/listOrderLogs',data,'get').then(res => {
        if (res.code == 200) {
              return Promise.resolve(res.data);
          } else {
              return Promise.reject((res && res.message) || "获取数据失败");
          }
      }).catch(error => {
          return Promise.reject(error);
      })
    },

    //复制订单
    orderCopy({commit},data){
      return tokenCall(Constant.tokenCallUrl + '/mxorder/order/info/copy',data,'get').then(res => {
        if (res.code == 200) {
              return Promise.resolve(res.data);
          } else {
              return Promise.reject((res && res.message) || "获取数据失败");
          }
      }).catch(error => {
          return Promise.reject(error);
      })
    },

    //获取料品树
    getMaterielTree({commit},data){
      return tokenCall(Constant.tokenCallUrl + '/mxorder//materiel/info/materielTree',data,'post').then(res => {
        if (res.code == 200) {
              return Promise.resolve(res.data);
          } else {
              return Promise.reject((res && res.message) || "获取数据失败");
          }
      }).catch(error => {
          return Promise.reject(error);
      })
    },





  },
  mutations: {
  	[types.ORDER_MSG](state, data) {
  		state.orderMsg = data;
  	},
  	[types.ORDER_MATE](state, data) {
  		state.orderMate = data;
  	},
    [types.TREE_DATA](state, data) {
      state.treeData = data;
    },
  },
  getters: {
    orderMsg: state => {
      return state.orderMsg || {orderMats:[]};
    },
    orderMate: state => {
      return state.orderMate || {};
    },
    treeData: state => {
      return state.treeData || {};
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/customOrder/index.js